// Which element actually scrolls the page depends on the area: the admin shell hands the page
// scroll to `.main-content` (see admin/layout.scss) while every other area still scrolls the
// document. Anything that reads or sets a page scroll position has to ask for the scroller rather
// than assume `window`.
//
// Resolve it on use, not once on connect — an area's content can start out short enough to fit and
// only become scrollable later, as images and turbo frames land.
//
// NB: to hear a scroll, don't try to attach to the result of this. Listen on `window` in the
// CAPTURE phase, which receives the scroll of the document and of any element alike.
export function scrollContainerFor(element) {
  let candidate = element

  while (candidate && candidate !== document.body && candidate !== document.documentElement) {
    if (isScrollable(candidate)) return candidate
    candidate = candidate.parentElement
  }

  return document.scrollingElement || document.documentElement
}

// A box only counts once it BOTH declares a scroll and has something to scroll. Declaring alone
// isn't enough to tell the two areas apart: `overflow-x: hidden` computes overflow-y to `auto`, so
// the non-admin `.main-content` claims to scroll while in truth it just grows with its content.
function isScrollable(element) {
  const overflowY = window.getComputedStyle(element).overflowY
  if (!["auto", "scroll", "overlay"].includes(overflowY)) return false

  return element.scrollHeight > element.clientHeight
}
